// extracted by mini-css-extract-plugin
export default {"imageContainer":"y1-z","summaryPar":"z1-z","ratingCategories":"A1-z","reviewerInfo":"B1-z","reviewTypes":"C1-z","expanded":"D1-z"};